export const initialState = {
    filter: {
        nameKeyword: null,
        status: null,
        evaluationPeriod: null,
        page: null,
        size: null
    },
    isFilter: false,
    typeAction: null
  };
  
  const answerEvaluationSearchReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SET_FILTER_ANSWER_EVALUATION":
        return {
          ...state,
          filter: action.filter,
          isFilter: action.isFilter,
          typeAction: action.typeAction,
        };
      default:
        return state;
    }
  };
  
  export default answerEvaluationSearchReducer;
  